module.exports = __webpack_public_path__ + "static/img/no_announcement.d21eb36c.svg";